export const PATH = {
  HOME: '/',
  MAP: '/map/',
  MAP_WIDGET_V1: '/map-widget/v1/',
  PRINT: '/print/',
  ADMIN: '/admin/',
};
